// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('ediExport', {
//         templateUrl: 'views/components/views/ediExport/ediExport.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['$stateParams', 'base64', 'ediExportService', function ($stateParams, base64, ediExportService) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;
//             let ediExportKeyno = $stateParams.edi_export_keyno;
            
//             vm.model = {
//                 bgEdiExportMain: {
//                     selected: 'DETAILS',
//                     buttons: [
//                         { id: 'DETAILS', label: 'gb_ediexport_main_details', color: 'primary', onClick: () => vm.model.bgEdiExportMain.selected = 'DETAILS' },
//                         { id: 'CONTENT', label: 'gb_ediexport_main_content', color: 'primary', onClick: () => vm.model.bgEdiExportMain.selected = 'CONTENT' },
//                         { id: 'FUNCTIONS', label: 'gb_ediexport_main_functions', color: 'primary', onClick: () => vm.model.bgEdiExportMain.selected = 'FUNCTIONS' }
//                     ]
//                 },
//                 edit: {},
//                 selectListEdiDestinations: [],
//                 selectListExportProcedures: []
//             };

//             // #endregion VARIABLES & DEFINITIONS

//             // #region LOAD PROCEDURE FUNCTION CALLS

//             async function loadEdit() {
//                 vm.model.edit = (await ediExportService.getEdit({ edi_export_keyno: ediExportKeyno }))[0];
//                 vm.model.edit.filecontent = base64.urldecode(vm.model.edit.filecontent);
//             }

//             async function loadEdiDestinations() {
//                 vm.model.selectListEdiDestinations = await ediExportService.listEdiDestinations();
//             }

//             async function loadExportProcedures() {
//                 vm.model.selectListExportProcedures = await ediExportService.listExportProcedures();
//             }

//             // #endregion LOAD PROCEDURE FUNCTION CALLS

//             // #region BUTTON RADIO FUNCTIONS

//             vm.selectBgEdiExportMain = function (value) {
//                 vm.model.bgEdiExportMain.selected = value;
//             }

//             // #endregion BUTTON RADIO FUNCTIONS

//             // #region ON INIT FUNCTION

//             vm.$onInit = async function () {
//                 loadEdit();
//                 loadEdiDestinations();
//                 loadExportProcedures();
//             }

//             // #endregion ON INIT FUNCTION

//         }]
//     });
// })();
